import React, { PureComponent } from 'react';
import b from 'b_';

import './datasets-page.css';

import DatasetItemStub from '@components/dataset-item/dataset-item.stub';

const class_ = b.with('datasets-page-stub');

export default class DatasetsPageStub extends PureComponent {
    public render() {
        return (
            <div className={class_()}>
                <DatasetItemStub type="horizontal" />
                <DatasetItemStub type="horizontal" />
                <DatasetItemStub type="horizontal" />
            </div>
        );
    }
}
